import * as React from 'react';

export const arrayToOptions = (arr) => (
  <React.Fragment>
    <option key="unselected" value="">Please Select</option>
    {arr.map((a, idx) => <option key={idx} value={a.value}>{a.label}</option>)}
  </React.Fragment>
);